import styles from './Loader.module.scss';

const Loader = ({ fullScreen = false }) => (
    <div className={`${styles.wrapper} ${fullScreen ? styles.fullScreen : ''}`}>
        <div className={styles.spinner} />
    </div>
);

export default Loader;
